/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendAdvancedProductConversionFieldDto } from '../../models/backend-advanced-product-conversion-field-dto';
import { BackendPatchedAdvancedProductConversionFieldRequestDto } from '../../models/backend-patched-advanced-product-conversion-field-request-dto';

export interface SalesAdvancedProductConversionFieldsPartialUpdate$Params {
  id: number;
  body?: BackendPatchedAdvancedProductConversionFieldRequestDto;
}

export function salesAdvancedProductConversionFieldsPartialUpdate(
  http: HttpClient,
  rootUrl: string,
  params: SalesAdvancedProductConversionFieldsPartialUpdate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendAdvancedProductConversionFieldDto>> {
  const rb = new RequestBuilder(rootUrl, salesAdvancedProductConversionFieldsPartialUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendAdvancedProductConversionFieldDto>;
    }),
  );
}

salesAdvancedProductConversionFieldsPartialUpdate.PATH = '/api/sales/advanced-product-conversion-fields/{id}/';
